import { jsx as _jsx } from "react/jsx-runtime";
import { QueuesDetailsPage } from 'components/settings/queues/containers/queuesDetailsPage';
export const SettingsQueuesCreateView = () => (_jsx(QueuesDetailsPage, { mode: "create" }));
